import $ from 'jQuery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';

$(function () {
    var $j = jQuery.noConflict();

    $j.datepicker._updateDatepicker_original = $j.datepicker._updateDatepicker;
    $j.datepicker._updateDatepicker = function (inst) {
        $j.datepicker._updateDatepicker_original(inst);
        var afterShow = this._get(inst, 'afterShow');
        if (afterShow) afterShow.apply(inst.input ? inst.input[0] : null);
    };

    $j('.datepicker').datepicker({
        firstDay: 1,
        dateFormat: 'dd.mm.yy',
        dayNames: ['Neděle', 'Pondělí', 'Uterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
        dayNamesMin: ['Ne', 'Po', 'Ut', 'St', 'Čt', 'Pá', 'So'],
        monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
        prevText: '&#x25C4;',
        nextText: '&#x25BA;',
        showOtherMonths: true,
        selectOtherMonths: true,
        showAnim: 'fadeIn',
        afterShow: function () {
            if ($('.ui-datepicker-prev').prop('title') != '') {
                $('.ui-datepicker-prev').prop('title', '');
            }
            if ($('.ui-datepicker-next').prop('title') != '') {
                $('.ui-datepicker-next').prop('title', '');
            }
        },
    });
});
